import React from 'react';
import Grid from '@material-ui/core/Grid';
import { InlineFilters } from 'features/command-center';
import { INLINE_FILTERS_KEYS } from 'features/command-center/constants';
import { useFeatureFlags } from 'providers/FeatureFlagsProvider';
import queryString from 'query-string';
import { FeatureFlags } from 'UI/constants/featureFlags';

import {
  ProductionBoardWidgets,
  ProductionByWeek,
  ProductionRoster,
  ProductionTracking,
  YTDProduction
} from './components';
import { useProductionBoard } from './hooks';
import { formatProductionBoardFilters } from './productionBoard.utils';

const INLINE_FILTERS = ['employeeNumbers', 'teams', 'employeeStatuses'];

export const ProductionBoard = () => {
  const { checkIfFeatureFlagEnabled } = useFeatureFlags();
  const showTracking = checkIfFeatureFlagEnabled(FeatureFlags.CommandCenterProductionBoardTracking);

  const { extraFilters, filters, handleLoadWidgetData, handleFiltersChange, widgetsValues } =
    useProductionBoard();

  const filtersParams = formatProductionBoardFilters(filters);
  const queryParams = queryString.stringify(filtersParams, { arrayFormat: 'comma' });

  return (
    <>
      <InlineFilters
        filters={INLINE_FILTERS}
        extraFilters={extraFilters}
        onFiltersChange={handleFiltersChange}
        persistenceKey={INLINE_FILTERS_KEYS.financial.productionBoard}
      />

      <Grid container spacing={3}>
        <ProductionBoardWidgets widgetsValues={widgetsValues} />

        <Grid item xs={12}>
          <ProductionByWeek queryParams={queryParams} onLoadWidgetData={handleLoadWidgetData} />
        </Grid>

        <Grid item xs={6}>
          <YTDProduction queryParams={queryParams} onLoadWidgetData={handleLoadWidgetData} />
        </Grid>

        <Grid item xs={6}>
          <ProductionRoster queryParams={queryParams} />
        </Grid>

        {showTracking && (
          <Grid item xs={12}>
            <ProductionTracking queryParams={queryParams} onLoadWidgetData={handleLoadWidgetData} />
          </Grid>
        )}
      </Grid>
    </>
  );
};
